export const Footer = {
    shops: 'فروشگاه ‌ها',
    goodsList: 'محصولات',
    aboutUs: 'ما را بشناسید',
    contactUs: 'ارتباط با ما',
    // contactUs: 'تماس با ما', 
    shopRequest:'ثبت فروشگاه',
    brands:'برند ها',
    faq:'سوالات متداول',
    copyRight: 'کلیه حقوق این وبسایت متعلق به لوکسین لوکس می‌باشد',
    rules: 'شرایط و قوانین سایت',
    blog: 'مجله لوکسین لوکس',
    app: 'نرم افزار لوکسین لوکس',
    luxgardi: 'لوکس گردی',
    discover_luxury: 'دنیای لوکست رو کشف کن',
}